function ProjectCard({ title, image, description }) {
	return (
		<div className="border rounded-lg overflow-hidden shadow-lg bg-white">
			<img src={image} alt={title} className="h-48 w-full object-cover" />
			<div className="p-4">
				<h3 className="text-xl font-bold">{title}</h3>
				<p className="mt-2">{description}</p>
			</div>
		</div>
	);
}

export default ProjectCard;
